const withdrawalApplications = [
  {
    id: "603ba7c35fc0320a8b0c51cb",
    applicationDate: "2021-02-28",
    applicationNumber: "APZ123",
    project: {
      id: 2333,
      code: "EGY0094",
      name: "South Helawn Power Plant Project",
      country: {
        code: "EG",
        name: "Egypt",
      },
    },
    operation: {
      id: 70000056,
      name: "Leasing / Islamic Development Bank",
    },
    requestedAmount: 1,
    requestedCurrency: {
      code: "USD",
      name: "United States Dollar",
      decimals: 2,
    },
    state: "Submitted",
    attachments: [
      {
        fileName: "tes.pdf",
        fileSize: 223320,
        filePath: null,
        id: "6ce61d7d-5527-407d-8e6f-9e44ac81e3c5",
        url: "http://localhost:8087/files/withdrawal-applications/6ce61d7d-5527-407d-8e6f-9e44ac81e3c5/tes.pdf",
        type: "withdrawal-applications"
      },
    ],
    modifiedAt: null,
    modifiedBy: {
      id: null,
      displayName: null,
    },
    createdAt: null,
    createdBy: {
      id: null,
      displayName: null,
    },
    deleted: false,
  },
  {
    id: "603534e1ed6cb629a9c2007f",
    applicationDate: "2021-02-10",
    applicationNumber: "123",
    requestedAmount: 1000000,
    requestedCurrency: {
      code: "USD",
      name: "United States Dollar",
      decimals: 2,
    },
    project: {
      id: 2333,
      code: "EGY0094",
      name: "South Helawn Power Plant Project",
      country: {
        code: "EG",
        name: "Egypt",
      },
    },
    operation: {
      id: 70000056,
      name: "Leasing / Islamic Development Bank",
    },
    state: "Draft",
    attachments: [
      {
        fileName: "tes.pdf",
        fileSize: 223320,
        filePath: null,
        id: "6ce61d7d-5527-407d-8e6f-9e44ac81e3c5",
        url: "http://localhost:8087/files/withdrawal-applications/6ce61d7d-5527-407d-8e6f-9e44ac81e3c5/tes.pdf",
        type: "withdrawal-applications"
      },
    ],
    modifiedAt: null,
    modifiedBy: {
      id: null,
      displayName: null,
    },
    createdAt: null,
    createdBy: {
      id: null,
      displayName: null,
    },
    deleted: false,
  },
  {
    id: "6035369392a6fc3c645a2e95",
    applicationDate: "2021-02-10",
    applicationNumber: "222",
    requestedAmount: 2000000,
    requestedCurrency: {
      code: "USD",
      name: "United States Dollar",
      decimals: 2,
    },
    project: {
      id: 2333,
      code: "EGY0094",
      name: "South Helawn Power Plant Project",
      country: {
        code: "EG",
        name: "Egypt",
      },
    },
    operation: {
      id: 70000056,
      name: "Leasing / Islamic Development Bank",
    },
    state: "Draft",
    attachments: [
      {
        fileName: "tes.pdf",
        fileSize: 223320,
        filePath: null,
        id: "6ce61d7d-5527-407d-8e6f-9e44ac81e3c5",
        url: "http://localhost:8087/files/withdrawal-applications/6ce61d7d-5527-407d-8e6f-9e44ac81e3c5/tes.pdf",
        type: "withdrawal-applications"
      },
    ],
    modifiedAt: null,
    modifiedBy: {
      id: null,
      displayName: null,
    },
    createdAt: null,
    createdBy: {
      id: null,
      displayName: null,
    },
    deleted: false,
  },
  {
    id: "6037a7adedf46f244122c719",
    applicationDate: "2021-02-10",
    applicationNumber: "333",
    requestedAmount: 2000000,
    requestedCurrency: {
      code: "USD",
      name: "United States Dollar",
      decimals: 2,
    },
    project: {
      id: 2333,
      code: "EGY0094",
      name: "South Helawn Power Plant Project",
      country: {
        code: "EG",
        name: "Egypt",
      },
    },
    operation: {
      id: 70000056,
      name: "Leasing / Islamic Development Bank",
    },
    state: "Draft",
    deleted: true,
  },
];

export default withdrawalApplications;
